import React from "react";

//material ui
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";

//components
import WantToApplyButton from "../Buttons/WantToApplyButton";

//img
import HomeBlueBackground from "../../img/HomeBlueBackground.png";
import CodingChallengeTitleBackground from "../../img/CodingChallengeTitleBackground.jpeg";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  box: {
    height: { xs: "457px", md: "580px", lg: "703px", xl: "827px" },
    width: "100%",
    backgroundImage: {
      xs: `url(${HomeBlueBackground})`,
      md: `url(${CodingChallengeTitleBackground})`,
    },
    borderRadius: { xs: "0 0 40px 40px", md: "inherit" },
    backgroundRepeat: "no-repeat",
    backgroundSize: { xs: "cover", md: "100% 100%" },
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: { xs: "center" },
    color: theme.palette.white.main,
  },
  homeBox: {
    display: { xs: "flex" },
    justifyContent: { xs: "center" },
    alignItems: { xs: "center", md: "flex-start" },
    flexDirection: { xs: "column" },
    width: { md: "850px", lg: "1100px", xl: "1150px" },
  },
  title: {
    maxWidth: { xs: "292px", md: "478px", lg: "663px" },
    textAlign: { xs: "center", md: "inherit" },
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "35px", md: "42px", lg: "49px", xl: "56px" },
    lineHeight: { xs: "43px", md: "59px", lg: "75px", xl: "92px" },
    mb: { xs: "21px", md: 0 },
    fontWeight: "bold",
    mt: { xs: "62px", md: "109px", lg: "156px", xl: "170px" },
  },
  span: { fontWeight: "bold" },
  subtitle: {
    maxWidth: { xs: "232px", md: "355px", lg: "415px", xl: "499px" },
    textAlign: { xs: "center", md: "start" },
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "16px", lg: "18px", xl: "22px" },
    lineHeight: { xs: "26px", md: "29px", lg: "32px", xl: "35px" },
    height: { xs: "133px" },
    mb: { xs: "36px", md: "21px" },
    mt: { md: "9px" },
  },
});

const CodingChallengeTitle = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const { title, subtitle } = useTranslation(pathname, "CodingChallengeTitle");

  return (
    <Box sx={classes.box}>
      <Box sx={classes.homeBox}>
        <Typography sx={classes.title}>{title}</Typography>
        <Typography sx={classes.subtitle}>
          {subtitle[0]}
          <span style={classes.span}>{subtitle[1]}</span>
          {subtitle[2]}
          <span style={classes.span}>{subtitle[3]}</span>
        </Typography>

        <WantToApplyButton
          navigateTo="/aplica"
          mainColor="#00edd5"
          iconColor="#0feed7"
          secondaryColor="#04a695"
          mb="67px"
          height={{
            xs: "52px",
            sm: "42.25px",
            md: "46.5px",
            lg: "60px",
            xl: "64px",
          }}
        />
      </Box>
    </Box>
  );
};

export default CodingChallengeTitle;
